module.exports = __webpack_public_path__ + "img/clip.e2076e04.svg";